import { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../assets/admin/css/dashboard.css';

const HeaderSection = () => {
    const [userDetail, setUserDetail] = useState({
        fname: "Guest",
        lname: "User",
        email: null,
        avatar: null,
    });
    const navigate = useNavigate();
    const { logout } = useAuth();
    const [menuActive, setMenuActive] = useState(false);

    // Toggle submenu visibility
    const handleProfileClick = () => {
        setMenuActive(!menuActive);
    };

    // Logout Handler
    const handleLogout = (e) => {
        e.preventDefault();
        logout(navigate);
    };

    useEffect(() => {
        try {
            // Retrieve user details from session storage
            const storedUser = sessionStorage.getItem("user_detail");
            if (storedUser) {
                setUserDetail(JSON.parse(storedUser));
            }
        } catch (error) {
           // console.error("Error retrieving user details:", error);
        }
    }, []);

    return (
        <div className="header-saction">
            <div className="right-header">
                <div className="profile-user">
                    <div className="profile" onClick={handleProfileClick}>
                        <div className="img-box">
                            {userDetail?.avatar ? (
                                <img src={userDetail.avatar} alt="Profile" />
                            ) : (
                                <i className="ph-bold ph-user"></i>
                            )}
                        </div>
                        <div className="user">
                            <h3>{userDetail?.fname+" "+userDetail?.lname}</h3>
                            <p>{userDetail?.email}</p>
                            <i className="fa fa-sort-desc" aria-hidden="true"></i>
                        </div>
                    </div>
                    {/* Submenu */}
                    <div className={`menu ${menuActive ? 'active' : ''}`}>
                        <ul>
                            <li>
                                <Link to="/admin/my-profile"><img src={`${process.env.PUBLIC_URL}/images/profile-icon-1.png`} alt="Countdown Timer" className='silver-icon' /> &nbsp;My Profile</Link>
                            </li>
                            <li>
                                <Link to="/admin/account-setting"><img src={`${process.env.PUBLIC_URL}/images/profile-icon-2.png`} alt="Countdown Timer" className='silver-icon' />&nbsp;Account Settings</Link>
                            </li>
                            <li>
                                <Link to="#" onClick={handleLogout}><img src={`${process.env.PUBLIC_URL}/images/profile-icon-4.png`} alt="Countdown Timer" className='silver-icon' />&nbsp;Sign Out</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderSection;
